import React from 'react';
import { cn } from '../helper/classNames';

interface TrendBadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  readonly value?: number | null;
  readonly positiveLabel?: string;
  readonly zeroLabel?: string;
  readonly negativeLabel?: string;
}

// A small, subtle badge that shows weekly change with shadcn-like styles.
// - > 0: green-ish subtle
// - = 0: neutral subtle
// - < 0: amber subtle
export function TrendBadge({
  value,
  className,
  positiveLabel = '+%d in letzter Woche',
  zeroLabel = '0 in letzter Woche',
  negativeLabel = '%d in letzter Woche',
  ...rest
}: TrendBadgeProps) {
  if (typeof value !== 'number') return null;

  const isPositive = value > 0;
  const isZero = value === 0;

  const label = isPositive
    ? positiveLabel.replace('%d', String(value))
    : isZero
    ? zeroLabel
    : negativeLabel.replace('%d', String(value));

  const base =
    'inline-flex items-center gap-1 rounded-md border px-2 py-0.5 text-xs transition-colors';

  const tone = isPositive
    ? 'border-green-200 text-green-700 bg-green-50 dark:bg-green-900/30 dark:border-green-800 dark:text-green-400'
    : isZero
    ? 'border-gray-200 dark:border-gray-700 text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-800'
    : 'border-amber-200 text-amber-700 bg-amber-50 dark:bg-amber-900/30 dark:border-amber-800 dark:text-amber-400';

  return (
    <span
      className={cn(base, tone, className)}
      {...rest}
    >
      {label}
    </span>
  );
}
